'use client'

import React from 'react'
import {useAuthClient} from '../utils/use-auth-client'
import {useAuth0} from '@auth0/auth0-react'
import {loadCountryRegistry} from '../utils/country-registry'

/**
 * @typedef {{
 *  Reporting_Center_Access?: boolean,
 *  BC_Catalog_Restrictions?: boolean,
 *  MC_Catalog_Restrictions?: boolean,
 *  BC_Catalog_Provisions_Pilot?: boolean,
 *  MC_Catalog_Provisions_Pilot?: boolean,
 *  TL_MC_Access?: boolean,
 *  Keap_Account_Ability?: boolean,
 *  Keap_Account_Management?: boolean,
 *  Demo_Region_Selection?: boolean,
 *  KeapMax_Catalog_Provisions?: boolean,
 *  Enable_Skip_Button_For_MC?: boolean,
 *  Enable_Skip_Button_For_Keap?: boolean,
 *  Skip_Appointment?: boolean,
 *  Enable_Professional_Services_Plan?: boolean,
 *  Vertical_Services_Plan?: boolean,
 *  ThryvHVAC_Catalog_Provisions?: boolean,
 *  Enable_GP_For_AU_And_NZ?: boolean,
 *  Enable_Social_Ads?: boolean,
 *  BC_Catalog_Update_Only?: boolean,
 *  Enable_KeapPartner_11Link?: boolean,
 *  BC_Enterprise?: boolean,
 *  Enable_Zapier?: boolean,
 *  Enable_Social_Ads_And_TL_With_BC?: boolean,
 *  MC_Free_Trial?: boolean,
 *  Enable_Listing_Refresh?: boolean,
 *  Orders_Menu_Access?: boolean,
 *  Custom_Data_Service_Access?: boolean,
 *  Custom_Data_For_You_Access?: boolean,
 *  Payment_Link_Copy_Button?: boolean,
 *  Enable_BNI_Leads_Lift?: boolean,
 *  Enable_BNI_Social_Ads?: boolean,
 *  Enable_BNI_Mktg_Svcs?: boolean,
 *  Enable_GB_Loc_Access?: boolean,
 *  TL_Tax_Plan_Enabled?: boolean,
 *  Feature_Flags_Read_Access?: boolean,
 *  Feature_Flags_Write_Access?: boolean,
 *  Proposal_Tool_Access?: boolean,
 *  Enable_Growth_Package?: boolean,
 *  Enable_International_Account_Creation?: boolean,
 *  Enable_CTN_US?: boolean,
 *  proposal_metrics?: boolean,
 *  Enable_Internal_Account_Checkbox?: boolean,
 *  Purchase_Links_Dashboard_Access?: boolean,
 *  Payment_Errors_Dashboard_Access?: boolean,
 *  Enable_AU_NZ_TGP_Upgrade?: boolean,
 *  Enable_US_TGP_Upgrade?: boolean,
 *  Enable_TGP_Downgrade?: boolean,
 *  Keap_Sandbox_Access?: boolean,
 *  Allow_MC_Starter?: boolean,
 *  Allow_Starter_Social_Ads?: boolean,
 * }} UserFeatures
 */

const UserFeaturesContext = React.createContext(null)

export function UserFeaturesProvider({children}) {
  const client = useAuthClient()
  const {user} = useAuth0()
  const [features, setFeatures] = React.useState({})

  const fetchUserFeatures = React.useCallback(async () => {
    return await client(`user/features`)
  }, [])

  React.useEffect(() => {
    if (!user) return
    loadCountryRegistry(client)
    fetchUserFeatures()
      .then(features => {
        setFeatures(features)
      })
      .catch(err => {
        console.error('Failed to fetch user features', err)
      })
  }, [user])

  return (
    <UserFeaturesContext.Provider value={features}>
      {children}
    </UserFeaturesContext.Provider>
  )
}

/**
 *
 * @returns {UserFeatures}
 */
export function useUserFeatures() {
  const context = React.useContext(UserFeaturesContext)
  if (!context) {
    throw new Error(
      "'useUserFeatures' can't be called outside 'UserFeaturesProvider'",
    )
  }
  return context
}
